var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal fade", attrs: { id: "rate-feedback-modal" } },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-body" }, [
            _vm._v(
              "\n                " + _vm._s(_vm.$t("ask")) + "\n            "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button", "data-dismiss": "modal" },
                on: { click: _vm.rateNo }
              },
              [_vm._v(_vm._s(_vm.$t("no")))]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-primary",
                attrs: {
                  href: "ms-windows-store://review/?ProductId=9NN76P3B5D8G"
                },
                on: { click: _vm.modalHide }
              },
              [_vm._v(_vm._s(_vm.$t("yes")))]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }